import _toConsumableArray from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _defineProperty from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"],
  _excluded2 = ["scope", "children"];
import * as e from "react";
export function createContext(t, n) {
  var o = /*#__PURE__*/e.createContext(n);
  function r(t) {
    var n = t.children,
      r = _objectWithoutProperties(t, _excluded),
      c = e.useMemo(function () {
        return r;
      }, Object.values(r)); /*#__PURE__*/
    return e.createElement(o.Provider, {
      value: c
    }, n);
  }
  return r.displayName = t + "Provider", [r, function (r) {
    var c = e.useContext(o);
    if (c) return c;
    if (void 0 !== n) return n;
    throw new Error("`".concat(r, "` must be used within `").concat(t, "`"));
  }];
}
export function createContextScope(n) {
  var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var r = [];
  var c = function c() {
    var t = r.map(function (t) {
      return /*#__PURE__*/e.createContext(t);
    });
    return function (o) {
      var r = (null == o ? void 0 : o[n]) || t;
      return e.useMemo(function () {
        return _defineProperty({}, "__scope".concat(n), _objectSpread(_objectSpread({}, o), {}, _defineProperty({}, n, r)));
      }, [o, r]);
    };
  };
  return c.scopeName = n, [function (t, o) {
    var c = /*#__PURE__*/e.createContext(o),
      u = r.length;
    function s(t) {
      var o = t.scope,
        r = t.children,
        s = _objectWithoutProperties(t, _excluded2),
        i = (null == o ? void 0 : o[n][u]) || c,
        a = e.useMemo(function () {
          return s;
        }, Object.values(s)); /*#__PURE__*/
      return e.createElement(i.Provider, {
        value: a
      }, r);
    }
    return r = [].concat(_toConsumableArray(r), [o]), s.displayName = t + "Provider", [s, function (r, s) {
      var i = (null == s ? void 0 : s[n][u]) || c,
        a = e.useContext(i);
      if (a) return a;
      if (void 0 !== o) return o;
      throw new Error("`".concat(r, "` must be used within `").concat(t, "`"));
    }];
  }, t.apply(void 0, [c].concat(_toConsumableArray(o)))];
}
function t() {
  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }
  var n = t[0];
  if (1 === t.length) return n;
  var o = function o() {
    var o = t.map(function (e) {
      return {
        useScope: e(),
        scopeName: e.scopeName
      };
    });
    return function (t) {
      var r = o.reduce(function (e, _ref2) {
        var n = _ref2.useScope,
          o = _ref2.scopeName;
        return _objectSpread(_objectSpread({}, e), n(t)["__scope".concat(o)]);
      }, {});
      return e.useMemo(function () {
        return _defineProperty({}, "__scope".concat(n.scopeName), r);
      }, [r]);
    };
  };
  return o.scopeName = n.scopeName, o;
}